import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Button, Summary } from '@sololearnorg/sol';
import { Container } from '../../../../../symphony';

import { getNotFoundPages, SlLEContext } from '../../../global-constants';
import { ActionType, RequestType } from '../../../global-interface';
import { SlActions } from '../../../services/ActionsService/sl-actions';
import { ActionButtonTypes } from '../../../../../shared/public/SlActionButton/SlActionButton';

import s from './CourseNotFound.scss';

export function CourseNotFound(): JSX.Element {
	useStyles(s);
	const onButtonClick = () => {
		const { actions$ } = Container.take(SlLEContext, SlActions);
		actions$.next({
			type: ActionType.OnCourseNotFoundClick,
			requestType: RequestType.Parallel,
		});
	};
	return (
		<div sl-test-data="cmpLECourseNotFound">
			<Summary
				actions={[
					<Button
						sl-test-data="btnCourseNotFound"
						type={ActionButtonTypes.primary}
						onClick={onButtonClick}
						key="btnCourseNotFound"
					>
						{getNotFoundPages().COURSE_NOT_FOUND.button.title}
					</Button>,
				]}
				className="le-not-found"
				description={getNotFoundPages().COURSE_NOT_FOUND.description}
				headline={getNotFoundPages().COURSE_NOT_FOUND.title}
			/>
		</div>
	);
}
